import { DSButton } from '@demandstar/components/button';
import { DSCheckbox } from '@demandstar/components/inputs';
import { isParentSelected } from 'src/components/products/helpers';

interface Commodity {
  commodityid: string | number;
  commodity: string;
  fullcode: string;
  formattedCode?: string;
}

interface InstantBidCommodityListProps {
  mergedCodes: Commodity[];
  checkedCommodities: Commodity[];
  onCheckboxChange: (commodity: Commodity) => void;
  onAddManually: () => void;
}

export function InstantBidCommodityList({
  mergedCodes,
  checkedCommodities,
  onCheckboxChange,
  onAddManually,
}: InstantBidCommodityListProps) {
  if (!mergedCodes.length) return null;

  return (
    <>
      <div className='d-flex align-items-center justify-content-between mt-2'>
        <h4 className='mb-2'>Relevant Commodity Codes ({mergedCodes.length})</h4>
          <a className='text-truncate cursor-pointer bold mr-4 underLine' onClick={onAddManually}>
          <>Edit Codes</>
        </a>
      </div>

      <div className='instantBidcommodityBlock mt-1'>
        {mergedCodes.map((commodity: Commodity) => {
          const currentCode = commodity.formattedCode || commodity.fullcode || '';
          const [group = '', category = '', code = ''] = currentCode.split('-');
          const isParentCode = code === '00';

          const directlySelected = checkedCommodities.some(
            item => String(item.commodityid) === String(commodity.commodityid),
          );

          const parentSelected = checkedCommodities.some(item => {
            const itemCode = item.formattedCode || item.fullcode || '';
            const [itemGroup = '', itemCategory = '', itemCode2 = ''] = itemCode.split('-');
            return itemGroup === group && itemCategory === category && itemCode2 === '00';
          });

          const isChecked = directlySelected || (!isParentCode && parentSelected);
          const isInactive =
            commodity.fullcode.endsWith('000-00') || (!isParentCode && parentSelected);

          return (
            <div key={commodity.commodityid}>
              <DSCheckbox
                name='checkbox'
                label={`[${commodity.fullcode}] : ${commodity.commodity}${
                  isParentSelected(commodity.fullcode, checkedCommodities)
                    ? ' - (Parent Selected)'
                    : ''
                }`}
                checked={isChecked}
                onClick={() => onCheckboxChange(commodity)}
                inactive={isInactive}
              />
            </div>
          );
        })}
      </div>
    </>
  );
}
